<app-canvas-badge class="hidden" #badge_component edizione_id="{{id_edizione}}"></app-canvas-badge>
<div *ngFor="let iscritto of iscritti">
  <div style="page-break-after:always;text-align:center;">
    <img style="width: 210mm;" [src]="iscritto.b64BadgeImage">
  </div>
</div>
